import { useEffect, useState } from "react"

const useToken = user =>{
    const [token, setToken] = useState('');
    useEffect(() =>{
        const email = user?.user?.email;
        const currentUser = {email: email};
        if(email){
            fetch(`https://ancient-ocean-03919.herokuapp.com/user/${email}`, {
                method: 'PUT',
                header:{
                    'content-type': 'application/json'
                },
                body: JSON.stringify(currentUser)
            })
            .then(res=> res.json())
            .then(data => {
                console.log('data inside useToken', data);
            })
        }
    },[user]);
    return [token];
}

export default useToken;